<template>
  <div>
    <b-sidebar
      id="sidebar-right"
      ref="mySidebar"
      bg-variant="white"
      v-model="visibility"
      sidebar-class="sidebar-lg"
      right
      no-header
      backdrop
      shadow
    >
      <div
        class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1"
      >
        <h5 class="mb-0">
          {{ $t(sidebarTitle) }}
        </h5>
        <feather-icon
          class="ml-1 cursor-pointer"
          icon="XIcon"
          size="16"
          @click="hideSideBar()"
        />
      </div>
      <b-form class="p-2" @submit.prevent>
        <b-row class="mt-1">
          <b-col md="12">
            <b-form-group
              :label="$t('Title')"
              :invalid-feedback="$t('Title is required')"
            >
              <b-form-input
                :placeholder="$t('Enter title.')"
                ref="title"
                v-model="myObj.title"
                @focusout="CheckTitle()"
              />
            </b-form-group>
          </b-col>
          <b-col md="12">
            <b-form-group
              :label="$t('Message')"
              :invalid-feedback="$t('Message is required.')"
              ref="msg"
            >
              <b-form-textarea
                ref="msg"
                :placeholder="$t('Enter message.')"
                v-model="myObj.message"
                @focusout="CheckMessage()"
                rows="5"
              ></b-form-textarea>
            </b-form-group>
          </b-col>

          <b-col md="12">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              type="submit"
              variant="success"
              class="mr-1 fullWidth"
              @click="Add()"
              :disabled="request"
              block
            >
              <b-spinner v-if="request" small type="grow" />
              <span v-if="request == false"> {{ $t(sidebarButton) }} </span>
            </b-button>
          </b-col>
        </b-row>
      </b-form>
    </b-sidebar>

    <b-card>
      <b-row class="mt-1">
        <!-- xl="10"
        lg="9"
        md="8" -->
        <b-col class="mt-lg-0 mt-md-0 mt-sm-1 mt-1" sm="12" cols="12">
          <b-form-group class="">
            <b-input-group>
              <b-input-group-prepend is-text>
                <feather-icon icon="SearchIcon" />
              </b-input-group-prepend>

              <b-form-input
                v-model="searchQuery"
                :placeholder="$t('Search') + '...'"
              >
              </b-form-input>
            </b-input-group>
          </b-form-group>
        </b-col>
        <!-- <b-col xl="2" lg="3" md="4" sm="12" cols="12">
          <b-button
            @click="deleteAll()"
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            block
          >
            <span class="align-middle"
              >{{ $t("Delete All") }} ({{ items.length }})</span
            >
          </b-button>
        </b-col> -->
      </b-row>

      <b-table
        class="mt-1"
        ref="selectableTable"
        :items="filters"
        :fields="fields"
        :current-page="currentPage"
        :per-page="perPage"
        :busy="dataLoading"
        show-empty
        responsive
        hover
      >
        <template #empty="scope">
          <h3 class="mt-1 mb-1 text-center">
            {{ $t("No records found") }}
          </h3>
        </template>
        <template #table-busy>
          <div class="d-flex justify-content-center mb-3 mt-3">
            <b-spinner
              style="width: 3rem; height: 3rem"
              type="grow"
              variant="primary"
              :label="$t('Spinning')"
            ></b-spinner>
          </div>
        </template>

        <template #head()="scope">
          <div>{{ $t(scope.label) }}</div>
        </template>

        <template #head(actions)="data">
          <div class="mr-5 text-right">
            <span>{{ $t(data.label) }}</span>
          </div>
        </template>

        <template #cell(meta_avatar)="data">
          <b-img
            v-if="data.value !== null && data.value !== ''"
            rounded
            :src="data.value"
            height="80px"
            width="80px"
            alt=""
          />
          <b-img
            v-else
            src="https://cdn.cloudious.net/file-1677912450367-333289208.png"
            height="80px"
            width="80px"
          />
        </template>
      </b-table>
      <b-col cols="12" class="d-flex align-items-center justify-content-center">
        <b-pagination
          v-model="currentPage"
          :total-rows="filters.length"
          :per-page="perPage"
          first-number
          last-number
          class="mb-0 mt-1 mt-sm-0"
          prev-class="prev-item"
          next-class="next-item"
        >
          <template #prev-text>
            <feather-icon icon="ChevronLeftIcon" size="18" />
          </template>
          <template #next-text>
            <feather-icon icon="ChevronRightIcon" size="18" />
          </template>
        </b-pagination>
      </b-col>
    </b-card>
  </div>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BTable,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
  BImg,
  VBTooltip,
  BFormGroup,
  BForm,
  BSpinner,
  BSidebar,
  VBToggle,
  BInputGroupPrepend,
  BInputGroup,
  BFormTextarea,
  BAvatar,
} from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
import vSelect from "vue-select";
import { mapActions, mapGetters } from "vuex";

export default {
  components: {
    BAvatar,
    BFormTextarea,
    BCard,
    BRow,
    BBadge,
    BTable,
    BCol,
    BFormInput,
    BButton,
    BSidebar,
    BFormGroup,
    BInputGroupPrepend,
    BInputGroup,
    BForm,
    BPagination,
    BSpinner,
    BImg,
    BDropdown,
    BDropdownItem,
    vSelect,
  },
  directives: {
    "b-tooltip": VBTooltip,
    "b-toggle": VBToggle,
    Ripple,
  },
  async created() {
    if (!this.$store.state.rights[this.$route.name]) {
      this.$router.replace({
        name: "misc-not-authorized",
      });
    } else {
      this.rights = this.$store.state.rights[this.$route.name];
      this.LoadData();
    }
  },
  computed: {
    filters: function () {
      return this.items.filter((pro) => {
        return (
          pro.meta_title.toLowerCase().match(this.searchQuery.toLowerCase()) ||
          pro.message.toLowerCase().match(this.searchQuery.toLowerCase())
        );
      });
    },
  },
  data() {
    return {
      rights: {},
      titleText: "This is title",
      request: false,
      visibility1: false,
      sidebarTitle: "Add Template",
      sidebarButton: "Save",
      buttonIcon: "PlusIcon",
      dataLoading: false,

      visibility: false,
      logoloading: "",
      searchQuery: "",
      currentPage: 1,
      perPage: 30,
      totalRows: 0,
      fields: [
        { label: "profile", key: "meta_avatar" },
        { label: "name", key: "meta_title" },
        { label: "message", key: "message" },
        { label: "number", key: "number" },
        // { key: "actions", label: "actions" },
      ],
      items: [],
      selected: null,
      rangeDate: null,
      myObj: {
        id: 0,
        title: "",
        message: "",
        campusID: this.$store.state.userData.cId,
      },
    };
  },
  methods: {
    ...mapActions({ get: "get", post: "post", put: "put", delete: "delete" }),

    async Edit(id) {
      var obj = {
        url:
          this.$store.state.domain +
          "MessageTemplate/GetSelected?id=" +
          id +
          "&db=" +
          this.$store.state.userData.db,
        token: this.$store.state.userData.token,
      };
      this.myObj = await this.get(obj);
      // console.log("editObj:", this.myObj);

      var elem = this.$refs["title"];
      elem.state = undefined;
      var elem = this.$refs["msg"];
      elem.state = undefined;

      this.sidebarTitle = "Edit Template";
      this.sidebarButton = "Update";
      this.visibility = true;
    },

    AddOpen() {
      this.myObj = {
        id: 0,
        title: "",
        message: "",
        campusID: this.$store.state.userData.cId,
      };
      var elem = this.$refs["title"];
      elem.state = undefined;
      var elem = this.$refs["msg"];
      elem.state = undefined;

      this.sidebarTitle = "Add Template";
      this.sidebarButton = "Save";
      this.visibility = true;
    },

    CheckTitle() {
      var elem = this.$refs["title"];
      if (this.myObj.title == "") {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    CheckMessage() {
      var elem = this.$refs["msg"];
      if (this.myObj.message == "") {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },

    hideSideBar() {
      this.visibility = false;
    },

    async LoadData() {
      this.dataLoading = true;
      var obj = {
        url:
          this.$store.state.domain +
          "Chat/LoadSentBox?db=" +
          this.$store.state.userData.db +
          "&cID=" +
          this.$store.state.userData.cId,
        token: this.$store.state.userData.token,
      };
      this.items = await this.get(obj);

      this.dataLoading = false;
      // console.log("items", this.items);
    },

    async Add() {
      this.CheckTitle();
      this.CheckMessage();
      if (this.CheckTitle() == false || this.CheckMessage() == false) {
        return this.$bvToast.toast(this.$t("Please fill the form correctly."), {
          title: this.$t("Error!"),
          variant: "danger",
          toaster: "b-toaster-top-center",
        });
      } else {
        if (this.myObj.id == 0) {
          //Add
          this.request = true;
          // console.log("obj:", this.myObj);
          var status = await this.post({
            url:
              this.$store.state.domain +
              "MessageTemplate?db=" +
              this.$store.state.userData.db,
            body: this.myObj,
            message: "Template added successfully.",
            context: this,
            token: this.$store.state.userData.token,
          });
          this.request = false;
          if (status) this.LoadData();
          this.visibility = false;
        } else {
          //Edit
          this.request = true;
          // console.log("edit_obj:", this.myObj);
          var status = await this.put({
            url:
              this.$store.state.domain +
              "MessageTemplate/" +
              this.myObj.id +
              "?db=" +
              this.$store.state.userData.db,
            body: this.myObj,
            message: "Template updated successfully.",
            context: this,
            token: this.$store.state.userData.token,
          });
          this.request = false;
          if (status) this.LoadData();
          this.visibility = false;
        }
      }
    },

    async Delete(id) {
      let result = await Swal.fire({
        title: this.$t("Are you sure?"),
        text: this.$t("You won't be able to revert this!"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
        confirmButtonText: this.$t("Yes, Delete it!"),
      });
      if (result.isConfirmed) {
        var status = await this.delete({
          url:
            this.$store.state.domain +
            "MessageTemplate/" +
            id +
            "?db=" +
            this.$store.state.userData.db,
          body: null,
          message: "Template removed successfully.",
          context: this,
          token: this.$store.state.userData.token,
        });
        // console.log(status);
        if (status) this.LoadData();
      }
    },

    async deleteAll() {
      var status = await this.post({
        url:
          this.$store.state.domain +
          "Chat/ClearSentBox?db=" +
          this.$store.state.userData.db +
          "&cID=" +
          this.$store.state.userData.cId,
        body: "",
        message: "Sentbox cleared!",
        context: this,
        token: this.$store.state.userData.token,
      });
      if (status) this.LoadData();
    },
  },
};
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}
</style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/libs/vue-flatpicker.scss";
</style>
<style scoped>
.image {
  float: left;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
  border: 1px solid #ebebeb;
  margin: 5px;
}
.card {
  transition: 0.4s;
}
.card:hover {
  box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.2);
}
</style>
